<template lang="pug">
.needs-meal-modal-table-component
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- セル：利用者グループ
    template(#cell(residentGroup)="row")
      span {{ row.item.residentGroupName }}
    //- セル：利用者名（部屋名）
    template(#cell(resident)="row")
      span {{ row.item.residentName }}（{{ row.item.roomName }}）
    //- セル：届出内容
    template(#cell(control)="row")
      button.btn.detail-btn(@click="onOoutingDetail(row.item)") 詳細
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { ExtNeedsMeal } from "@/commons/services/Outings";

import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * ### 外出外泊届けテーブルコンポーネント
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class NeedsMealModalTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<NeedsMealModalTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<NeedsMealModalTableField>;

  get _value(): Array<NeedsMealModalTableItem> {
    return this.value;
  }

  /**
   * ### 届出内容 詳細ボタン押下イベント処理
   */
  public onOoutingDetail(item: NeedsMealModalTableItem): void {
    this.$emit("onOoutingDetail", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface NeedsMealModalTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface NeedsMealModalTableItem extends ExtNeedsMeal {
  /** 利用者グループ名 */
  residentGroupName: string;
}

export enum MealType {
  /** 朝食 */
  BREAKFAST = "breakfast",
  /** 昼食 */
  LUNCH = "lunch",
  /** おやつ */
  SNACK = "snack",
  /** 夕食 */
  DINNER = "dinner"
}

export interface FilterSetting {
  id: string;
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.outing-table-component {
  .detail-btn,
  .consented-btn,
  .refuse-btn {
    min-width: 57px;
  }
  .cancel-btn {
    min-width: 120px;
  }
}
</style>
